<template>
  <div class="permission-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="permissionModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="permissionModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="Controller" prop="controller">
            <Input v-model="permissionModel.controller" placeholder="输入Controller名称" />
          </FormItem>
          <FormItem label="Action" prop="action">
            <Input v-model="permissionModel.action" placeholder="输入action名称(“*”代表全部动作)" />
          </FormItem>
          <FormItem label="行业/领域/地区专属">
            <i-switch v-model="permissionModel.isPrivate" size="large">
              <span slot="open">专属</span>
              <span slot="close">通用</span>
            </i-switch>
          </FormItem>
          <FormItem label="需要CA签名">
            <i-switch v-model="permissionModel.needCert" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="需要多因素验证">
            <i-switch v-model="permissionModel.needMultiFactor" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="专属城市" prop="ownedByCityId" v-if="permissionModel.isPrivate">
            <!-- <Input v-model="industryModel.cityId" placeholder="输入城市" /> -->
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择专属城市"></Cascader>
          </FormItem>
          <FormItem label="专属行业/领域" prop="ownedByIndustryId" v-if="permissionModel.isPrivate">
            <Select v-model="permissionModel.ownedByIndustryId" filterable placeholder="选择专属行业/领域">
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'permission-new',
  props: {
  },
  data () {
    const validatePrivate = (rule, value, callback) => {
      if (this.permissionModel.isPrivate && 
        !this.permissionModel.ownedByCityId &&
        !this.permissionModel.ownedByIndustryId) {
        callback(new Error('专属城市、行业领域最少填写一项'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      loading: false,
      permissionModel: {
        name: null,
        controller: null,
        action: null,
        isPrivate: false,
        needCert: false,
        needMultiFactor: false,
        ownedByCityId: null,
        ownedByIndustryId: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        controller: [
          { required: true, message: '请填写Controller名称', trigger: 'blur' }
        ],
        action: [
          { required: true, message: '请填写Action名称', trigger: 'blur' }
        ],
        ownedByCityId: [
          { validator: validatePrivate, trigger: 'blur' }
        ],
        ownedByIndustryId: [
          { validator: validatePrivate, trigger: 'blur' }
        ]
      },
      cities: [],
      industries: []
    }
  },
  watch: {
  },
  mounted () {
    this.initCitySelect()
    this.initIndustrySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    initIndustrySelect () {
      Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.permissionModel.ownedByCityId = val[val.length - 1]
      } else {
        this.permissionModel.ownedByCityId = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.BasicPermission.addBasicPermission(this.permissionModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.permissionModel= {
                name: null,
                controller: null,
                action: null,
                isPrivate: false,
                needCert: false,
                needMultiFactor: false,
                ownedByCityId: null,
                ownedByIndustryId: null
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
